var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import { TimezoneType } from "../../data/TimezoneType";
import getLocationSamples from "../../requests/metrics/getLocationSamples";
/**
 *
 */
var GetLocationSamplesCommand = /** @class */ (function (_super) {
    __extends(GetLocationSamplesCommand, _super);
    function GetLocationSamplesCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param locationSampleCollection LocationSampleCollection
     * @param organisation OrganisationModel
     * @param assetIDs Array metricsDbIds
     * @param interval
     * @param timeRange
     * @param timezone
     * @return {*}
     */
    GetLocationSamplesCommand.prototype.execute = function (locationSampleCollection, organisation, assetIDs, interval, timeRange, timezone) {
        if (timezone === void 0) { timezone = TimezoneType["Europe/Amsterdam"]; }
        this.locationSampleCollection = locationSampleCollection;
        var promise = getLocationSamples(organisation, assetIDs, interval, timeRange, timezone);
        promise.then(this.then);
        return promise;
    };
    GetLocationSamplesCommand.prototype.then = function (response) {
        // assetData
        var samples = [];
        Object.keys(response.assetData).forEach(function (assetMetricsId) {
            return response.assetData[assetMetricsId].forEach(function (sample) {
                samples.push({
                    assetMetricsId: assetMetricsId,
                    timestamp: sample[0],
                    path: sample[1],
                    firstLat: sample[5],
                    firstLong: sample[6],
                    lastLat: sample[7],
                    lastLong: sample[8]
                });
            });
        });
        this.locationSampleCollection.reset();
        this.locationSampleCollection.addAll(samples);
    };
    return GetLocationSamplesCommand;
}(Command));
export default GetLocationSamplesCommand;
